var _style, _g, _defs, _polygon, _polygon2, _circle, _polygon3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlucoseLevelsZincIntake({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8EEE1;}\n\t.st1{clip-path:url(#XMLID_2_);fill:#EFC05D;}\n\t.st2{clip-path:url(#XMLID_2_);fill:#E6393D;}\n\t.st3{fill:#2A384F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.8,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.3,148.7,63,183.2,105.8,183.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000176759753401909599390000013071747292550436515_",
    d: "M148.9,106.8c-3.9,0-7.2-3-7.4-6.8 c-1.1-21.9-18.1-31.7-34.5-31.7S73.6,78.2,72.6,100c-0.2,3.9-3.7,7-7.7,6.8c-4.1-0.2-7.2-3.5-7-7.4c0.7-13.9,6.3-25.6,16.4-33.9 C83,58.1,94.7,54.1,107,54.1s24,4,32.9,11.3c10,8.3,15.7,20,16.4,33.9c0.2,3.9-3,7.3-7,7.4C149.1,106.8,149,106.8,148.9,106.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000176759753401909599390000013071747292550436515_",
    style: {
      overflow: "visible",
      fill: "#EE8F61"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000176759753401909599390000013071747292550436515_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "101.6,97.4 62.7,120.4 26.7,64.1 65.7,41.1  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "113.4,97.4 152.3,120.4 188.3,64.1 149.4,41.1  "
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 108.9,
    cy: 95.7,
    r: 6.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "101,61 112.3,91.9 104.5,93.8 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.1,154.1v-6.8L96.8,123H79.4v-6.3h27.4v5.9l-20.5,25.2h21.3v6.3H77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.6,154.1h-7.2v-13.8c0-2.9-0.2-4.8-0.5-5.7c-0.3-0.9-0.8-1.5-1.5-2c-0.7-0.5-1.5-0.7-2.5-0.7 c-1.2,0-2.4,0.3-3.3,1c-1,0.7-1.7,1.6-2,2.7s-0.5,3.2-0.5,6.2v12.3h-7.2V127h6.7v4c2.4-3.1,5.3-4.6,8.9-4.6c1.6,0,3,0.3,4.3,0.9 c1.3,0.6,2.3,1.3,3,2.2c0.7,0.9,1.1,1.9,1.4,3c0.3,1.1,0.4,2.7,0.4,4.8V154.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlucoseLevelsZincIntake);
export default __webpack_public_path__ + "static/media/GlucoseLevels_ZincIntake.625075244a87f1b46b9d9b8901986c9a.svg";
export { ForwardRef as ReactComponent };